"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasRequiredProperties = exports.Required = void 0;
const validator_1 = require("@leavy/validator");
const validator_2 = require("@leavy/validator/lib/base/validator");
function Required() {
    return (target, propertyKey) => {
        (0, validator_1.IsDefined)({ groups: ["required"], always: true })(target, propertyKey);
    };
}
exports.Required = Required;
function hasRequiredProperties(obj) {
    const validationErrors = (0, validator_2.validateSync)(obj, {
        groups: ["required"],
        stopAtFirstError: true,
    });
    return validationErrors.length == 0;
}
exports.hasRequiredProperties = hasRequiredProperties;
//# sourceMappingURL=Required.js.map